import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {EllipsisTooltipDirective} from "./ellipsis-tooltip.directive";
import { ProjectItemThumbnailCardHoverDirective } from "./project-item-thumbnail-card-hover.directive";
import { NumbersOnlyDirective } from "./numbers-only.directive";
import { ElevateElementDirective } from './elevate-element.directive';


@NgModule({
	declarations: [
		ProjectItemThumbnailCardHoverDirective,
		EllipsisTooltipDirective,
		NumbersOnlyDirective,
		ElevateElementDirective
	],
	imports: [
		CommonModule
	],
	exports: [
		ProjectItemThumbnailCardHoverDirective,
		EllipsisTooltipDirective,
		NumbersOnlyDirective,
		ElevateElementDirective
	]
})
export class SharedDirectiveModule { }
